import { ErrorBanner } from 'ui/banner';
import { isNonEmptyArray } from 'utils/tsHelpers';
import { useQueryErrorStateContext } from '../contexts';
import { useTranslation } from '../hooks/useTranslation';
import { useIsCatalogESIndex } from '../hooks/useIsCatalogESIndex';

export const QueryErrorBanner = () => {
  const { t } = useTranslation();
  const isCatalogESIndex = useIsCatalogESIndex();
  const { pathErrors } = useQueryErrorStateContext();

  return isNonEmptyArray(pathErrors) ? (
    <ErrorBanner>{t(`banner.error.${isCatalogESIndex ? 'catalog' : 'userAndEvent'}`)}</ErrorBanner>
  ) : null;
};
